import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import aboutHero from "../assets/villa13.jpeg";

import img1 from "../assets/villa1.jpeg";
import img2 from "../assets/villa2.jpeg";
import img3 from "../assets/villa3.jpeg";
import img4 from "../assets/villa4.jpeg";
import img5 from "../assets/villa5.jpeg";
import img6 from "../assets/villa6.jpeg";
import img7 from "../assets/villa7.jpeg";
import img8 from "../assets/villa8.jpeg";
import img9 from "../assets/villa9.jpeg";
import img10 from "../assets/villa10.jpeg";
import img11 from "../assets/villa11.jpeg";
import img12 from "../assets/villa12.jpeg";
import img13 from "../assets/villa13.jpeg";
import img14 from "../assets/villa14.jpeg";

function Gallary() {

    useEffect(() => {
        AOS.init({ duration: 900, once: true });
    }, []);

    const galleryImages = [
        img1, img2, img3, img4, img5, img6, img7,
        img8, img9, img10, img11, img12, img13, img14
    ];

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[60vh] w-full">
                <img
                    src={aboutHero}
                    alt="Gallery Hero"
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60" />
                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white px-4">
                    <h1
                        data-aos="fade-up"
                        className="text-4xl border border-[#c97b3a] bg-black/40 backdrop-blur-sm p-6 sm:p-5 sm:text-3xl md:text-4xl font-bold mb-3"
                    >
                        Gallery
                    </h1>
                </div>
            </section>

            {/* ================= GALLERY SECTION ================= */}
            <section className="py-20 px-6 md:px-16 bg-[#f8f6f3]">

                <div className="text-center mb-16">
                    <p className="text-sm tracking-widest text-[#c97b3a] uppercase">
                        Gallery
                    </p>
                    <h2 className="text-3xl md:text-5xl font-serif text-gray-800 mt-3">
                        Visual Tales of Luxury & Elegance
                    </h2>
                </div>

                {/* Masonry Grid */}
                <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
                    {galleryImages.map((img, index) => (
                        <div
                            key={index}
                            data-aos="fade-up"
                            className="overflow-hidden rounded-lg shadow-md break-inside-avoid"
                        >
                            <img
                                src={img}
                                alt="Gallery"
                                className="w-full h-auto object-cover hover:scale-105 transition duration-500"
                            />
                        </div>
                    ))}
                </div>
            </section>

            {/* ================= WHATSAPP FLOAT BUTTON ================= */}
            <a
                href="https://wa.me/94764806045?text=I%20saw%20your%20website.%20Can%20you%20give%20me%20information%20regarding%20your%20villa."
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition hover:scale-110"
                />
            </a>
        </div>
    );
}

export default Gallary;